module.exports = "<div class=\"modal-content\">\n    <div class=\"modal-header bg-danger\">\n        <em class=\"fa fa-warning\"></em><span style=\"margin-left: 10px;\" translate>Warning</span>\n    </div>\n    <div class=\"modal-body text-center\">{{ content }}</div>\n    <div class=\"modal-footer\">\n        <button type=\"button\" class=\"btn btn-default\" ng-click=\"$dismiss()\" translate>Cancel</button>\n        <button type=\"button\" class=\"btn btn-danger\" ng-click=\"$close()\" translate>Delete</button>\n    </div>\n</div>";


//////////////////
// WEBPACK FOOTER
// ./src/cmsCore/DeleteElementModal/deleteElementModal.html
// module id = 937
// module chunks = 0